module.exports = __webpack_public_path__ + "img/kl8lhc_icon.87e2bbe7.png";